import React from 'react';
import styled from 'styled-components';
import { colors } from '../../style-utils/colors';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background: ${colors.white};
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
  padding: 32px 24px;
  min-width: 320px;
  max-width: 90vw;
  text-align: center;
`;

const ModalTitle = styled.h2`
  color: ${colors.purple_dark};
  margin-bottom: 16px;
  font-size: 1.25rem;
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
`;

export interface StyledModalProps {
  open: boolean;
  title?: string;
  children?: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

export const StyledModal: React.FC<StyledModalProps> = ({
  open,
  title,
  children,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) => {
  if (!open) return null;

  return (
    <ModalOverlay>
      <ModalContainer>
        {title && <ModalTitle>{title}</ModalTitle>}
        {children}
        <ModalActions>
          <button
            style={{
              background: colors.purple_dark,
              color: colors.white,
              border: 'none',
              borderRadius: '6px',
              padding: '8px 20px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
          <button
            style={{
              background: colors.grey_light,
              color: colors.black,
              border: 'none',
              borderRadius: '6px',
              padding: '8px 20px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
            onClick={onCancel}
          >
            {cancelText}
          </button>
        </ModalActions>
      </ModalContainer>
    </ModalOverlay>
  );
};
